import React, { useState, useEffect } from 'react';
import Papa from 'papaparse';
import {
  Box,
  Container,
  VStack,
  Heading,
  Text
} from '@chakra-ui/react';
import { AlertCircle } from 'lucide-react';
import { SurveyData } from '../types/data';
import Dashboard from './Dashboard';

const DataLoader: React.FC = () => {
  const [data, setData] = useState<SurveyData[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string>('');


  useEffect(() => {
    const loadData = async () => {
      try {
        setLoading(true);
        setError('');

        const response = await fetch('/clean_data_salud_mental_dev.csv');
        if (!response.ok) {
          throw new Error('No se pudo cargar el archivo de datos');
        }

        const csvText = await response.text();
        
        Papa.parse(csvText, {
          header: true,
          skipEmptyLines: true,
          complete: (results) => {
            if (results.errors.length > 0) {
              setError('Errores al procesar el archivo CSV');
              console.error('CSV parsing errors:', results.errors);
              return;
            }

            const parsedData = results.data as SurveyData[];
            setData(parsedData);
            setLoading(false);
          },
          error: (error: any) => {
            setError('Error al procesar el archivo CSV');
            console.error('CSV parsing error:', error);
            setLoading(false);
          }
        });
      } catch (err) {
        setError('Error al cargar los datos');
        console.error('Data loading error:', err);
        setLoading(false);
      }
    };

    loadData();
  }, []);

  if (loading) {
    return (
      <Box className="professional-loading-container">
        <Container maxW="container.sm">
          <VStack gap={8}>
            <Box className="professional-spinner" />
            <VStack gap={4}>
              <Heading size="lg" className="professional-loading-text">
                Cargando Datos
              </Heading>
              <Text className="professional-loading-subtext">
                Procesando archivo de datos de salud mental pastoral...
              </Text>
            </VStack>
          </VStack>
        </Container>
      </Box>
    );
  }

  if (error) {
    return (
      <Box className="professional-error-container">
        <Container maxW="container.sm">
          <Box className="professional-error-card">
            <Box className="professional-error-icon">
              <AlertCircle size={24} />
            </Box>
            <Heading className="professional-error-title">
              Error al Cargar Datos
            </Heading>
            <Text className="professional-error-message">
              {error}
            </Text>
          </Box>
        </Container>
      </Box>
    );
  }

  if (data.length === 0) {
    return (
      <Box className="professional-error-container">
        <Container maxW="container.sm">
          <Box className="professional-warning-card">
            <Box className="professional-warning-icon">
              <AlertCircle size={24} />
            </Box>
            <Heading className="professional-error-title">
              Datos No Encontrados
            </Heading>
            <Text className="professional-error-message">
              El archivo de datos está vacío o no contiene registros válidos.
            </Text>
          </Box>
        </Container>
      </Box>
    );
  }

  return (
    <Box minH="100vh">
      {/* Main Dashboard */}
      <Dashboard data={data} />
    </Box>
  );
};

export default DataLoader;
